import { memo, useContext, useEffect, useMemo, type FunctionComponent } from 'react';
// Skillmore UI Components
import FetchFailedAlert from '@empathco/ui-components/src/elements/FetchFailedAlert';
import LoadingPlaceholder from '@empathco/ui-components/src/elements/LoadingPlaceholder';
// local imports
import { getTbFetchMessage } from '../constants/teamBuilderErrors';
import { SupervisorContext } from '../context/supervisor';
import TbReviewBar from '../v3/TbReviewBar';
import TbRosterList from '../v3/TbRosterList';
import TbSkillsList from '../v3/TbSkillsList';

type TeamBuilderReviewProps = {
  readonly teamId: number;
}

const TeamBuilderReview: FunctionComponent<TeamBuilderReviewProps> = ({
  teamId
}) => {
  const {
    tbTeam: { data: team, pending, failed, notFound, forbidden }, requireTbTeam
  } = useContext(SupervisorContext);
  const { title, skills, employees } = team || {};

  useEffect(() => {
    if (teamId) requireTbTeam?.({ team_id: teamId });
  }, [teamId, requireTbTeam]);

  const failureMessage = useMemo(() => getTbFetchMessage(notFound, forbidden), [notFound, forbidden]);

  if (failed) return <FetchFailedAlert flat message={failureMessage}/>;

  return (
    <>
      <TbReviewBar
          teamId={teamId}
          title={title}
          roster={employees || []}
          skills={skills || []}
          pending={pending || !team ? true : undefined}
          disabled={pending ? true : undefined}
      />
      {(pending && <LoadingPlaceholder flat/>) || (
        <>
          <TbRosterList roster={employees || []}/>
          <TbSkillsList skills={skills || []}/>
        </>)}
    </>
  );
};

export default memo(TeamBuilderReview);
